import { buttonGroupClasses } from '@mui/material/ButtonGroup';
import { Components, Theme } from '@mui/material/styles';

import * as Shadows from 'src/theme/shadows';
import ColorUtils from 'src/utils/ColorUtils';

const MuiButtonGroup: Components<Theme>['MuiButtonGroup'] = {
  styleOverrides: {
    grouped: {
      minWidth: 'auto',
    },
    contained: {
      boxShadow: Shadows.PrimaryButtonShadow,
      // `disabled` reaches the buttons, never the group, so the group drops its
      // shared shadow itself once no button inside is enabled.
      [`&:not(:has(> .${buttonGroupClasses.grouped}:not(.Mui-disabled)))`]: {
        boxShadow: 'none',
      },
    },
    groupedContainedPrimary: ({ theme }) => ({
      border: `1px solid ${
        ColorUtils.GetColorDarknessShades(theme.palette.primary.main).dark
      }`,
    }),
    groupedHorizontal: {
      '&:not(:last-child)': {
        marginRight: 1,
      },
      '&:not(:first-child)': {
        borderLeft: 'none',
      },
    },
    groupedContainedHorizontal: {
      '&:not(:last-child)': {
        borderRight: 'none',
      },
    },
  },
};

export default MuiButtonGroup;
